import { render, staticRenderFns } from "./loopHandleList.vue?vue&type=template&id=2905023d&scoped=true"
import script from "./loopHandleList.vue?vue&type=script&lang=js"
export * from "./loopHandleList.vue?vue&type=script&lang=js"
import style0 from "./loopHandleList.vue?vue&type=style&index=0&id=2905023d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2905023d",
  null
  
)

export default component.exports